import React, { PureComponent, Component } from 'react';
import { Steps } from 'antd';
import { Card } from 'antd';
import { Layout } from 'antd';
import { Table } from 'reactstrap';
import Slider from "react-slick";
// import SchedulingOrderSlideCards from './SchedulingOrderSlideCards';
import Image from 'react-bootstrap/lib/Image';
import Grid from 'react-bootstrap/lib/Grid';
import { Row, Col, Divider, Icon, Popover } from 'antd';
import { Button, Modal } from 'antd';
import { CardTitle } from 'reactstrap';
import openSocket from 'socket.io-client';
const colSep = String.fromCharCode(14);
const rowSep = String.fromCharCode(15);
const Step = Steps.Step;
const confirmModal = Modal.confirm;
// const url = "http://50.233.95.54:10069";
let siteName = "", selectedDate = "";
let thisContext = null;

class SchedulingOrderSlideCards extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            siteName: "",
            userName: "",
            selectedDate: "",
            isRunning: false,
            runningSorder: "",
            activeCardIdx: 0,
            selectedOperid: "ALL",
            visiblePopoverGC: false,
            visiblePopoverSchAll: false,
            visiblePopoverStpAll: false,
            visiblePopoverRstAll: false,
            visiblePopoverFnzAll: false,
            visiblePopoverKllClt: false
        };
        // this.clearMetricsBeforeRun = this.clearMetricsBeforeRun.bind(this);
        // this.handleBtnClkAll = this.handleBtnClkAll.bind(this);
        this.handlePopoverVisibleChangeGC = this.handlePopoverVisibleChangeGC.bind(this);
        this.handlePopoverVisibleChangeSchAll = this.handlePopoverVisibleChangeSchAll.bind(this);
        this.handlePopoverVisibleChangeStpAll = this.handlePopoverVisibleChangeStpAll.bind(this);
        this.handlePopoverVisibleChangeRstAll = this.handlePopoverVisibleChangeRstAll.bind(this);
        this.handlePopoverVisibleChangeFnzAll = this.handlePopoverVisibleChangeFnzAll.bind(this);
        this.handlePopoverVisibleChangeKllClt = this.handlePopoverVisibleChangeKllClt.bind(this);
    }

    componentDidMount() {
        document.getElementById("myRightTopNav").style.height = "240px";
        document.getElementById("myRightTopNav").children[1].children[0].style.margin = "auto";
        document.getElementById("myRightTopNav").children[1].children[0].style.marginTop = "10px";
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps != null && nextProps.data != null) {
            this.initCards(nextProps);
            this.setState({ data: nextProps.data });
            this.setState({ selectedDate: nextProps.selectedDate.replace("-20", "-") });
            this.setState({ siteName: nextProps.userName.toUpperCase() });
            this.setState({ selectedOperid: nextProps.selectedOperid });
            if (nextProps.data < 2) {
                this.setState({ activeCardIdx: 1 });
            }
            if (this.state.isRunning) {
                let aIsDone = true;
                if (this.state.runningSorder === "all") {
                    for (var i = 0; i < nextProps.data.length; i++) {
                        if (nextProps.data[i].when_ended === null || nextProps.data[i].when_ended.length === 0) {
                            aIsDone = false;
                            break;
                        }
                    }
                } else if (this.state.runningSorder.indexOf("-") >= 0) {
                    for (var i = 0; i < nextProps.data.length; i++) {
                        try {
                            if ((nextProps.data[i].sorder !== null && (nextProps.data[i].sorder >= parseInt(this.state.runningSorder.split("-")[0]) && nextProps.data[i].sorder <= parseInt(this.state.runningSorder.split("-")[1]))) && (nextProps.data[i].when_ended === null || nextProps.data[i].when_ended.length === 0)) {
                                aIsDone = false;
                                break;
                            }
                        } catch (e) {
                            aIsDone = false;
                            break;
                        }
                    }
                } else {
                    for (var i = 0; i < nextProps.data.length; i++) {
                        if ((nextProps.data[i].sorder !== null && nextProps.data[i].sorder.toString() === this.state.runningSorder) && (nextProps.data[i].when_ended === null || nextProps.data[i].when_ended.length === 0)) {
                            aIsDone = false;
                            break;
                        }
                    }
                }
                if (aIsDone) {
                    this.schedulingFinishes();
                } else {
                    // this.props.startMonitorSchedulingOrder(this.state.runningSorder);
                }
            }
            if (nextProps.isMonitorSchedulingOrderDone && this.state.isRunning) {

            }
        }
        if (nextProps.activeCardIdx !== this.state.activeCardIdx) {
            this.setState({ activeCardIdx: nextProps.activeCardIdx });
            this.initCards(nextProps);
        }
        if (nextProps.selectedOperid !== this.state.selectedOperid) {
            this.setState({ selectedOperid: nextProps.selectedOperid });
        }
    }

    schedulingFinishes() {
        this.setState({ isRunning: false });
        this.setState({ runningSorder: "" });
        this.props.endMonitorSchedulingOrder();
        document.getElementById("reset_all_btn").disabled = false;
        document.getElementsByClassName("schedule_all_btn")[0].disabled = false;
        for (var i = 0; i < this.state.data.length; i++) {
            if (!this.isEmptyObj(this.state.data[i])) {
                document.getElementById("run_btn_" + this.state.data[i].sorder).disabled = false;
                document.getElementById("run_btn_" + this.state.data[i].sorder).style.display = "block";
                document.getElementById("stop_btn_" + this.state.data[i].sorder).style.display = "none";
            }
        }
        document.getElementsByClassName("stop_all_btn")[0].style.display = "none";
        document.getElementsByClassName("schedule_all_btn")[0].style.display = "block";
        document.getElementById("finalize_btn").disabled = false;
        let socket = openSocket(this.props.GSENodeJsUrl);
        socket.on('finish', function (data) {
            console.log('Caught Event "finish" after calling cmd, data: ' + data);
        });
        // socket.emit("-kill", this.state.siteName, this.state.selectedDate);
    }

    handleRunBtnClkRun(e) {
        console.log(e);
        this.props.disableOperidSelection();
        let aSorder = e.target.id.replace("run_btn_", "");
        this.setState({ runningSorder: aSorder });
        document.getElementsByClassName("schedule_all_btn")[0].disabled = true;
        document.getElementById("reset_all_btn").disabled = true;
        for (var i = 0; i < this.state.data.length; i++) {
            if (!this.isEmptyObj(this.state.data[i])) {
                document.getElementById("run_btn_" + this.state.data[i].sorder).disabled = true;
            }
        }
        document.getElementById(e.target.id).style.display = "none";
        document.getElementById("stop_btn_" + aSorder).style.display = "block";
        document.getElementById("finalize_btn").disabled = true;
        // return;
        let aUrl = this.props.QRydeMappBaseUrl + '613ClearMetrics?data=' + this.state.selectedDate + colSep + this.state.siteName + colSep + this.state.selectedOperid + colSep + aSorder;
        fetch(aUrl)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result != null && result.cmd_name != null && result.cmd_name === '613ClearMetrics' && result.status != null
                        && result.status === 'OK') {
                        this.setState({ isRunning: true });
                        let socket = openSocket(this.props.GSENodeJsUrl);
                        thisContext = this;
                        socket.on('finish', function (data) {
                            console.log('Caught Event "finish" after calling cmd, data: ' + data);
                            thisContext.schedulingFinishes();
                            Modal.success({
                                title: data
                                // content: 'All schedules are removed.'
                            });
                        });
                        // socket.emit("-b", "PENQUIS", aSorder, "02-MAY-18");
                        // socket.emit("-b", "ATLANTIC", aSorder, this.state.selectedDate);
                        // socket.emit("-b", this.state.siteName, aSorder, this.state.selectedDate);
                        socket.emit("-b", this.state.siteName, this.state.selectedDate.toUpperCase(), aSorder, this.state.selectedOperid);
                        this.props.startMonitorSchedulingOrder(aSorder);
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    handleStopBtnClkRun(e) {
        this.setState({ isRunning: false });
        this.setState({ runningSorder: "" });
        // this.props.endMonitorSchedulingOrder();
        // this.props.enableSelectOperid();
        this.schedulingFinishes();
        let aSorder = e.target.id.replace("stop_btn_", "");
        document.getElementById(e.target.id).style.display = "none";
        document.getElementById("run_btn_" + aSorder).style.display = "block";
        document.getElementById("reset_all_btn").disabled = false;
        document.getElementsByClassName("schedule_all_btn")[0].disabled = false;
        for (var i = 0; i < this.state.data.length; i++) {
            if (!this.isEmptyObj(this.state.data[i])) {
                document.getElementById("run_btn_" + this.state.data[i].sorder).disabled = false;
            }
        }
        let socket = openSocket(this.props.GSENodeJsUrl);
        socket.on('finish', function (data) {
            console.log('Caught Event "finish" after calling cmd, data: ' + data);
        });
        // socket.emit("-kill", "PENQUIS", "02-MAY-18");
        // socket.emit("-kill", "ATLANTIC", this.state.selectedDate);
        socket.emit("-kill", this.state.siteName, this.state.selectedDate.toUpperCase());
    }

    handleBtnClkAll(e) {
        if (this.props.GseSplitBatch != null && typeof this.props.GseSplitBatch == "boolean" && this.props.GseSplitBatch) {
            this.props.openScheduleAllDialog();
        } else {
            this.props.disableOperidSelection();
            this.setState({ runningSorder: "all" });
            document.getElementsByClassName("stop_all_btn")[0].style.display = "block";
            document.getElementsByClassName("schedule_all_btn")[0].style.display = "none";
            document.getElementById("reset_all_btn").disabled = true;
            document.getElementById("finalize_btn").disabled = true;
            for (var i = 0; i < this.state.data.length; i++) {
                if (!this.isEmptyObj(this.state.data[i])) {
                    document.getElementById("run_btn_" + this.state.data[i].sorder).disabled = true;
                }
            }
            document.getElementsByClassName("schedule_all_btn")[0].disabled = true;
            let aUrl = this.props.QRydeMappBaseUrl + '613ClearMetrics?data=' + this.state.selectedDate + colSep + this.state.siteName + colSep + this.state.selectedOperid + colSep + "ALL";
            fetch(aUrl)
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result != null && result.cmd_name != null && result.cmd_name === '613ClearMetrics' && result.status != null
                            && result.status === 'OK') {
                            this.setState({ isRunning: true });
                            console.log("Run All");
                            this.props.startMonitorSchedulingOrder("all");
                            // return;
                            let socket = openSocket(this.props.GSENodeJsUrl);
                            thisContext = this;
                            socket.on('finish', function (data) {
                                console.log('Caught Event "finish" after calling cmd, data: ' + data);
                                thisContext.schedulingFinishes();
                                Modal.success({
                                    title: data
                                    // content: 'All schedules are removed.'
                                });
                            });
                            // socket.emit("-b", "ATLANTIC", "ALL", "10-MAY-18");
                            // socket.emit("-v", "PENQUIS", "02-MAY-18");
                            // socket.emit("-kill", "PENQUIS", "02-MAY-18");
                            // this.props.startMonitorSchedulingOrder("all");
                            // socket.emit("-b", "PENQUIS", "ALL", "02-MAY-18");
                            // socket.emit("-b", "ATLANTIC", "ALL", this.state.selectedDate);
                            // socket.emit("-b", this.state.siteName, "ALL", this.state.selectedDate);
                            socket.emit("-b", this.state.siteName, this.state.selectedDate.toUpperCase(), "ALL", this.state.selectedOperid);
                        }
                    },
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
    }

    handleBtnClkRange(theStartSorder, theEndSorder) {
        this.props.disableOperidSelection();
        this.setState({ runningSorder: theStartSorder + "-" + theEndSorder });
        document.getElementsByClassName("stop_all_btn")[0].style.display = "block";
        document.getElementsByClassName("schedule_all_btn")[0].style.display = "none";
        document.getElementById("reset_all_btn").disabled = true;
        document.getElementById("finalize_btn").disabled = true;
        for (var i = 0; i < this.state.data.length; i++) {
            if (!this.isEmptyObj(this.state.data[i])) {
                document.getElementById("run_btn_" + this.state.data[i].sorder).disabled = true;
            }
        }
        document.getElementsByClassName("schedule_all_btn")[0].disabled = true;
        let aUrl = this.props.QRydeMappBaseUrl + '613ClearMetrics?data=' + this.state.selectedDate + colSep + this.state.siteName + colSep + this.state.selectedOperid + colSep + "ALL";
        fetch(aUrl)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result != null && result.cmd_name != null && result.cmd_name === '613ClearMetrics' && result.status != null
                        && result.status === 'OK') {
                        this.setState({ isRunning: true });
                        console.log("Run " + theStartSorder + "-" + theEndSorder);
                        this.props.startMonitorSchedulingOrder(theStartSorder + "-" + theEndSorder);
                        // return;
                        let socket = openSocket(this.props.GSENodeJsUrl);
                        thisContext = this;
                        socket.on('finish', function (data) {
                            console.log('Caught Event "finish" after calling cmd, data: ' + data);
                            thisContext.schedulingFinishes();
                            Modal.success({
                                title: data
                                // content: 'All schedules are removed.'
                            });
                        });
                        // socket.emit("-b", "ATLANTIC", "ALL", "10-MAY-18");
                        // socket.emit("-v", "PENQUIS", "02-MAY-18");
                        // socket.emit("-kill", "PENQUIS", "02-MAY-18");
                        // this.props.startMonitorSchedulingOrder("all");
                        // socket.emit("-b", "PENQUIS", "ALL", "02-MAY-18");
                        // socket.emit("-b", "ATLANTIC", "ALL", this.state.selectedDate);
                        // socket.emit("-b", this.state.siteName, "ALL", this.state.selectedDate);
                        socket.emit("-b", this.state.siteName, this.state.selectedDate.toUpperCase(), theStartSorder + "-" + theEndSorder, this.state.selectedOperid);
                        console.log("sending -b cmd with params: " + this.state.siteName + ", " + this.state.selectedDate.toUpperCase() + ", " + theStartSorder + "-" + theEndSorder + ", " + this.state.selectedOperid);
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    handleBtnStopAll(e) {
        this.setState({ isRunning: false });
        this.setState({ runningSorder: "" });
        // this.props.endMonitorSchedulingOrder();
        // this.props.enableSelectOperid();
        this.schedulingFinishes();
        document.getElementById("reset_all_btn").disabled = false;
        document.getElementsByClassName("schedule_all_btn")[0].disabled = false;
        for (var i = 0; i < this.state.data.length; i++) {
            if (!this.isEmptyObj(this.state.data[i])) {
                document.getElementById("run_btn_" + this.state.data[i].sorder).disabled = false;
            }
        }
        document.getElementsByClassName("stop_all_btn")[0].style.display = "none";
        document.getElementsByClassName("schedule_all_btn")[0].style.display = "block";
        let socket = openSocket(this.props.GSENodeJsUrl);
        socket.on('finish', function (data) {
            console.log('Caught Event "finish" after calling cmd, data: ' + data);
        });
        // socket.emit("-kill", "PENQUIS", "02-MAY-18");
        // socket.emit("-kill", "ATLANTIC", this.state.selectedDate);
        socket.emit("-kill", this.state.siteName, this.state.selectedDate.toUpperCase());
    }

    handleRestAll() {
        let socket = openSocket(this.props.GSENodeJsUrl);
        let aDate = new Date(this.state.selectedDate);
        thisContext = this;
        socket.on('finish', function (data) {
            console.log('Caught Event "finish" after calling cmd, data: ' + data);
            Modal.success({
                title: 'Schedules have been successfully reset for ' + (aDate.getMonth() + 1) + '/' + aDate.getDate() + '/' + aDate.getFullYear() + '.'
                // content: 'All schedules are removed.'
            });
            document.getElementById("reset_all_btn").disabled = false;
            document.getElementsByClassName("schedule_all_btn")[0].disabled = false;
            document.getElementById("finalize_btn").disabled = false;
            for (var i = 0; i < thisContext.state.data.length; i++) {
                if (!thisContext.isEmptyObj(thisContext.state.data[i])) {
                    document.getElementById("run_btn_" + thisContext.state.data[i].sorder).disabled = false;
                }
            }
        });
        // socket.emit("-restart", "PENQUIS", "02-MAY-18");
        // socket.emit("-restart", "ATLANTIC", this.state.selectedDate);
        socket.emit("-restart", this.state.siteName, this.state.selectedDate.toUpperCase(), this.state.selectedOperid);
    }

    handleKillClientDate() {
        let socket = openSocket(this.props.GSENodeJsUrl);
        let aDate = new Date(this.state.selectedDate);
        thisContext = this;
        socket.on('finish', function (data) {
            console.log('Caught Event "finish" after calling cmd, data: ' + data);
            Modal.success({
                title: 'Client date have been successfully killed for ' + (aDate.getMonth() + 1) + '/' + aDate.getDate() + '/' + aDate.getFullYear() + '.'
                // content: 'All schedules are removed.'
            });
            document.getElementById("kill_client_date_btn").disabled = false;
            document.getElementsByClassName("schedule_all_btn")[0].disabled = false;
            document.getElementById("finalize_btn").disabled = false;
            for (var i = 0; i < thisContext.state.data.length; i++) {
                if (!thisContext.isEmptyObj(thisContext.state.data[i])) {
                    document.getElementById("run_btn_" + thisContext.state.data[i].sorder).disabled = false;
                }
            }
        });
        socket.emit("-killshm", this.state.siteName, this.state.selectedDate.toUpperCase(), "Y");
    }

    handleGenerateClusters() {
        let aUrl = this.props.QRydeMappBaseUrl + '613GetAliasGeohash?data=' + this.props.userName.toUpperCase();
        fetch(aUrl)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result != null && result.cmd_name != null && result.cmd_name === '613GetAliasGeohash' && result.status != null
                        && result.status === 'OK') {
                        Modal.success({
                            title: 'Clusters have been successfully generated.'
                        });
                    } else {
                        Modal.error({
                            title: 'Error generating clustes. Please try again later.'
                        });
                    }
                    document.getElementById("generate_clusters_btn").disabled = false;
                },
                (error) => {
                    document.getElementById("generate_clusters_btn").disabled = false;
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    handleFinalize() {
        let socket = openSocket(this.props.GSENodeJsUrl);
        let aDate = new Date(this.state.selectedDate);
        thisContext = this;
        socket.on('finish', function (data) {
            console.log('Caught Event "finish" after calling cmd, data: ' + data);
            document.getElementById("finalize_btn").disabled = false;
        });
        console.log("Calling -finalize Cmd with: " + this.state.siteName + "~" + this.state.selectedDate.toUpperCase() + "~" + this.state.selectedOperid);
        socket.emit("-finalize", this.state.siteName, this.state.selectedDate.toUpperCase(), this.state.selectedOperid);
    }

    showConfirmRestAll() {
        document.getElementById("reset_all_btn").disabled = true;
        document.getElementsByClassName("schedule_all_btn")[0].disabled = true;
        document.getElementById("finalize_btn").disabled = true;
        for (var i = 0; i < this.state.data.length; i++) {
            if (!this.isEmptyObj(this.state.data[i])) {
                document.getElementById("run_btn_" + this.state.data[i].sorder).disabled = true;
            }
        }
        thisContext = this;
        let aDate = new Date(this.state.selectedDate);
        confirmModal({
            title: 'Do you want to reset all schedules for ' + (aDate.getMonth() + 1) + '/' + aDate.getDate() + '/' + aDate.getFullYear() + '?',
            // content: 'When clicked the Confirm button, all schedules for selected date will be removed.',
            okText: 'Confirm',
            okType: 'danger',
            onOk() {
                if (thisContext != null) {
                    thisContext.handleRestAll();
                }
            },
            onCancel() {
                document.getElementById("reset_all_btn").disabled = false;
                document.getElementsByClassName("schedule_all_btn")[0].disabled = false;
                document.getElementById("finalize_btn").disabled = false;
                for (var i = 0; i < thisContext.state.data.length; i++) {
                    if (!thisContext.isEmptyObj(thisContext.state.data[i])) {
                        document.getElementById("run_btn_" + thisContext.state.data[i].sorder).disabled = false;
                    }
                }
            }
        });
    }

    showConfirmKllClt() {
        document.getElementById("kill_client_date_btn").disabled = true;
        document.getElementsByClassName("schedule_all_btn")[0].disabled = true;
        document.getElementById("finalize_btn").disabled = true;
        for (var i = 0; i < this.state.data.length; i++) {
            if (!this.isEmptyObj(this.state.data[i])) {
                document.getElementById("run_btn_" + this.state.data[i].sorder).disabled = true;
            }
        }
        thisContext = this;
        let aDate = new Date(this.state.selectedDate);
        confirmModal({
            title: 'Do you want to kill client date for ' + (aDate.getMonth() + 1) + '/' + aDate.getDate() + '/' + aDate.getFullYear() + '?',
            // content: 'When clicked the Confirm button, all schedules for selected date will be removed.',
            okText: 'Confirm',
            okType: 'danger',
            onOk() {
                if (thisContext != null) {
                    thisContext.handleKillClientDate();
                }
            },
            onCancel() {
                document.getElementById("kill_client_date_btn").disabled = false;
                document.getElementsByClassName("schedule_all_btn")[0].disabled = false;
                document.getElementById("finalize_btn").disabled = false;
                for (var i = 0; i < thisContext.state.data.length; i++) {
                    if (!thisContext.isEmptyObj(thisContext.state.data[i])) {
                        document.getElementById("run_btn_" + thisContext.state.data[i].sorder).disabled = false;
                    }
                }
            }
        });
    }

    ShowConfirmGenerateClusters() {
        document.getElementById("generate_clusters_btn").disabled = true;
        thisContext = this;
        confirmModal({
            title: 'Do you want to generate clusters?',
            okText: 'Confirm',
            onOk() {
                if (thisContext != null) {
                    thisContext.handleGenerateClusters();
                }
            },
            onCancel() {
                document.getElementById("generate_clusters_btn").disabled = false;
            }
        });
    }

    ShowConfirmFinalize() {
        document.getElementById("finalize_btn").disabled = true;
        thisContext = this;
        let aDate = new Date(this.state.selectedDate);
        confirmModal({
            title: 'Do you want to finalize all schedules for ' + (aDate.getMonth() + 1) + '/' + aDate.getDate() + '/' + aDate.getFullYear() + '?',
            okText: 'Confirm',
            okType: 'danger',
            onOk() {
                if (thisContext != null) {
                    thisContext.handleFinalize();
                }
            },
            onCancel() {
                document.getElementById("finalize_btn").disabled = false;
            }
        });
    }

    onActiveCardIdxChange(current) {
        // this.setState({ activeCardIdx: current });
        if (this.state.data.length > 1) {
            this.props.handelSchedulingOrderIdxChange(current);
            // this.setState({ activeCardIdx: current });
            // this.state.activeCardIdx = current;
            // this.initCards(this.state);
        }
        this.setState({
            visiblePopoverGC: false,
            visiblePopoverSchAll: false,
            visiblePopoverStpAll: false,
            visiblePopoverRstAll: false,
            visiblePopoverFnzAll: false,
            visiblePopoverKllClt: false
        })
    }

    /* hidePopoverGC = () => {
        this.setState({ visiblePopoverGC: true });
    } */

    handlePopoverVisibleChangeGC = (visible) => {
        this.setState({
            visiblePopoverGC: visible,
            visiblePopoverSchAll: false,
            visiblePopoverStpAll: false,
            visiblePopoverRstAll: false,
            visiblePopoverFnzAll: false,
            visiblePopoverKllClt: false
        })
        this.initCards(this.props);
    }

    handlePopoverVisibleChangeSchAll = (visible) => {
        this.setState({
            visiblePopoverGC: false,
            visiblePopoverSchAll: visible,
            visiblePopoverStpAll: false,
            visiblePopoverRstAll: false,
            visiblePopoverFnzAll: false,
            visiblePopoverKllClt: false
        });
        this.initCards(this.props);
    }

    handlePopoverVisibleChangeStpAll = (visible) => {
        this.setState({
            visiblePopoverGC: false,
            visiblePopoverSchAll: false,
            visiblePopoverStpAll: visible,
            visiblePopoverRstAll: false,
            visiblePopoverFnzAll: false,
            visiblePopoverKllClt: false
        });
        this.initCards(this.props);
    }

    handlePopoverVisibleChangeRstAll = (visible) => {
        this.setState({
            visiblePopoverGC: false,
            visiblePopoverSchAll: false,
            visiblePopoverStpAll: false,
            visiblePopoverRstAll: visible,
            visiblePopoverFnzAll: false,
            visiblePopoverKllClt: false
        });
        this.initCards(this.props);
    }

    handlePopoverVisibleChangeFnzAll = (visible) => {
        this.setState({
            visiblePopoverGC: false,
            visiblePopoverSchAll: false,
            visiblePopoverStpAll: false,
            visiblePopoverRstAll: false,
            visiblePopoverFnzAll: visible,
            visiblePopoverKllClt: false
        });
        this.initCards(this.props);
    }

    handlePopoverVisibleChangeKllClt = (visible) => {
        this.setState({
            visiblePopoverGC: false,
            visiblePopoverSchAll: false,
            visiblePopoverStpAll: false,
            visiblePopoverRstAll: false,
            visiblePopoverFnzAll: false,
            visiblePopoverKllClt: true
        });
        this.initCards(this.props);
    }

    initCards(props) {
        let aTempCards = [];
        let aWheelchairImg = "";
        let aWhichRunning = -1;
        for (var i = 0; i < props.data.length; i++) {
            if (!this.isEmptyObj(props.data[i])) {
                if (props.data[i].when_started != null && props.data[i].when_started.length != 0 && (props.data[i].when_ended == null || props.data[i].when_ended.length == 0)) {
                    aWhichRunning = props.data[i].sorder;
                    break;
                }
            }
        }
        if (true) {
            if (false) {
                aTempCards.push(
                    <div className="item" style={{ width: 200, float: "center" }}>
                        <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ padding: 8, backgroundColor: "lightblue", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }} >
                            <div>
                                {/* <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <h4>Schedule All</h4>
                                </Col>
            </Row> */}
                                <div style={{ height: 15 }} />
                                <Row type="flex" justify="space-between" align="middle">
                                    <Button id="generate_clusters_btn" type="primary" style={{ width: 138, margin: "auto" }} onClick={this.ShowConfirmGenerateClusters.bind(this)}>Generate Clusters</Button>
                                </Row>
                                <div style={{ height: 23 }} />
                                <Row type="flex" justify="space-between" align="middle">
                                    <Button className="schedule_all_btn" type="primary" style={{ width: 138, margin: "auto" }} onClick={(e) => this.handleBtnClkAll(e)}>Schedule All</Button>
                                    <Button className="stop_all_btn" type="danger" style={{ width: 138, margin: "auto", display: "none" }} onClick={(e) => this.handleBtnStopAll(e)}>Stop All</Button>
                                </Row>
                                <div style={{ height: 23 }} />
                                <Row type="flex" justify="space-between" align="middle">
                                    <Button id="reset_all_btn" type="primary" style={{ width: 138, margin: "auto" }} /* onClick={(e) => this.showConfirmRestAll(e)} */ onClick={this.showConfirmRestAll.bind(this)}>Reset Schedules</Button>
                                </Row>
                                <div style={{ height: 15 }} />
                            </div>
                        </Card>
                    </div>
                )
            } else {
                if (false) {
                    aTempCards.push(
                        <div className="item" style={{ width: 200, float: "center" }}>
                            <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ padding: 8, backgroundColor: "lightblue", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }} >
                                <div style={{ paddingTop: 8, paddingBottom: 8 }}>
                                    <Row type="flex" justify="space-around" align="middle">
                                        <Col style={{ padding: 20, paddingRight: 15 }}  >
                                            <Popover placement="leftTop" content={(<div><p>Schedule All</p></div>)} title="Schedule All" >
                                                {/* <Icon type="clock-circle-o" style={{ fontSize: 38, color: '#08c' }} onClick={(e) => this.handleBtnClkAll(e)}/> */}
                                                <Button className="schedule_all_btn" type="primary" icon="clock-circle-o" style={{ height: 38, width: 38, fontSize: 20, padding: "auto" }} onClick={(e) => this.handleBtnClkAll(e)} />
                                            </Popover>
                                            <Popover placement="leftTop" content={(<div><p>Stop All</p></div>)} title="Stop All" >
                                                {/* <Icon type="close-circle-o" style={{ fontSize: 38, color: '#ff1a1a' }} /> */}
                                                <Button className="stop_all_btn" type="danger" icon="close-circle-o" style={{ height: 38, width: 38, fontSize: 20, padding: "auto", display: "none" }} onClick={(e) => this.handleBtnStopAll(e)} />
                                            </Popover>
                                        </Col>
                                        {/* <Col style={{ padding: 20, paddingRight: 15, display: "none" }} >
                                            <Popover placement="leftTop" content={(<div><p>Stop scheduling for all S-Orders</p></div>)} title="Stop All" >
                                                <Button className="stop_all_btn" type="danger"  icon="close-circle-o" style={{height:38, width:38, fontSize:20, padding: "auto"}} onClick={(e) => this.handleBtnStopAll(e)} />
                                            </Popover>
                                        </Col> */}
                                        <Divider type="vertical" style={{ fontSize: 38 }} />
                                        <Col style={{ padding: 20, paddingLeft: 15 }} >
                                            <Popover placement="topRight" content={(<div><p>Reset Schedules</p></div>)} title="Reset Schedules" >
                                                {/* <Icon type="retweet" style={{ fontSize: 38, color: '#08c', pointerEvents: "none" }} onClick={this.showConfirmRestAll.bind(this)} /> */}
                                                <Button id="reset_all_btn" type="primary" icon="retweet" style={{ height: 38, width: 38, fontSize: 20, padding: "auto" }} onClick={this.showConfirmRestAll.bind(this)} />
                                            </Popover>
                                        </Col>
                                    </Row>
                                    <Row type="flex" justify="space-around" align="middle" style={{ height: 1 }}>
                                        <Divider type="horizontal" style={{ width: 38, paddingLeft: 20 }} />
                                        <Divider type="horizontal" style={{ width: 38, paddingRight: 20 }} />
                                    </Row>
                                    <Row type="flex" justify="space-around" align="middle">
                                        <Col style={{ padding: 20, paddingRight: 15 }} >
                                            <Popover placement="leftBottom" content={(<div><p>Generate Clusters</p></div>)} title="Generate Clusters">
                                                {/* <Icon type="api" style={{ fontSize: 38, color: '#08c' }} /> */}
                                                <Button id="generate_clusters_btn" type="primary" icon="api" style={{ height: 38, width: 38, fontSize: 20, padding: "auto" }} onClick={this.ShowConfirmGenerateClusters.bind(this)} />
                                            </Popover>
                                        </Col>
                                        <Divider type="vertical" style={{ fontSize: 38 }} />
                                        <Col style={{ padding: 20, paddingLeft: 15 }} >
                                            <Popover placement="bottomRight" content={(<div><p>Finalize</p></div>)} title="Finalize">
                                                {/* <Icon type="check-square-o" style={{ fontSize: 38, color: '#08c' }} /> */}
                                                <Button id="finalize_btn" type="primary" icon="check-square-o" style={{ height: 38, width: 38, fontSize: 20, padding: "auto" }} onClick={this.ShowConfirmFinalize.bind(this)} />
                                            </Popover>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        </div>
                    )
                } else {
                    aTempCards.push(
                        <div className="item" style={{ width: 200, float: "center" }}>
                            <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ padding: 8, backgroundColor: "lightblue", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }} >
                                <div style={{ paddingTop: 8, paddingBottom: 8 }}>
                                    <Row type="flex" justify="space-around" align="middle">
                                        <Col style={{ padding: 6, paddingRight: 15 }}  >
                                            <Popover placement="leftTop" trigger="hover" visible={this.state.visiblePopoverGC} onVisibleChange={this.handlePopoverVisibleChangeGC} content={(<div><p>Prepare trips for scheduling.</p></div>)} title="Generate Clusters">
                                                <Button id="generate_clusters_btn" type="primary" icon="api" style={{ height: 38, width: 38, fontSize: 20, padding: "auto" }} onClick={this.ShowConfirmGenerateClusters.bind(this)} />
                                            </Popover>
                                        </Col>
                                        <Divider type="vertical" style={{ fontSize: 38 }} />
                                        <Col style={{ padding: 6, paddingLeft: 15 }} >
                                            <Popover placement="topRight" trigger="hover" visible={this.state.visiblePopoverSchAll} onVisibleChange={this.handlePopoverVisibleChangeSchAll} content={(<div><p>Schedule unassigned trips for the selected operator.<br></br>Pre-assigned trips will not be affected.</p></div>)} title="Schedule All" >
                                                <Button className="schedule_all_btn" type="primary" icon="clock-circle-o" style={{ height: 38, width: 38, fontSize: 20, padding: "auto" }} onClick={(e) => this.handleBtnClkAll(e)} />
                                            </Popover>
                                            <Popover placement="topRight" trigger="hover" visible={this.state.visiblePopoverStpAll} onVisibleChange={this.handlePopoverVisibleChangeStpAll} content={(<div><p>Stop the scheduling process.</p></div>)} title="Stop All" >
                                                <Button className="stop_all_btn" type="danger" icon="close-circle-o" style={{ height: 38, width: 38, fontSize: 20, padding: "auto", display: "none" }} onClick={(e) => this.handleBtnStopAll(e)} />
                                                <span style={{paddingLeft: 2, display: aWhichRunning > 0 ? "inline-block" : "none"}}>{aWhichRunning}</span>
                                            </Popover>
                                        </Col>
                                    </Row>
                                    {/* <Row type="flex" justify="space-around" align="middle" style={{ height: 1 }}>
                                        <Divider type="horizontal" style={{ width: 38, paddingLeft: 20 }} />
                                        <Divider type="horizontal" style={{ width: 38, paddingRight: 20 }} />
                    </Row> */}
                                    <Row type="flex" justify="space-around" align="middle">
                                        <Col style={{ padding: 6, paddingRight: 15 }} >
                                            <Popover placement="leftBottom" trigger="hover" visible={this.state.visiblePopoverRstAll} onVisibleChange={this.handlePopoverVisibleChangeRstAll} content={(<div><p>Undo the last scheduling action.</p></div>)} title="Reset Schedules" >
                                                <Button id="reset_all_btn" type="primary" icon="retweet" style={{ height: 38, width: 38, fontSize: 20, padding: "auto" }} onClick={this.showConfirmRestAll.bind(this)} />
                                            </Popover>
                                        </Col>
                                        <Divider type="vertical" style={{ fontSize: 38 }} />
                                        <Col style={{ padding: 6, paddingLeft: 15 }} >
                                            <Popover placement="bottomRight" trigger="hover" visible={this.state.visiblePopoverFnzAll} onVisibleChange={this.handlePopoverVisibleChangeFnzAll} content={(<div><p>Prevent unintentional resets and<br></br>enable other dispatch related functions.</p></div>)} title="Finalize">
                                                {/* <Icon type="check-square-o" style={{ fontSize: 38, color: '#08c' }} /> */}
                                                <Button id="finalize_btn" type="primary" icon="check-square-o" style={{ height: 38, width: 38, fontSize: 20, padding: "auto" }} onClick={this.ShowConfirmFinalize.bind(this)} />
                                            </Popover>
                                        </Col>
                                    </Row>
                                    <Row type="flex" justify="space-around" align="middle">
                                        <Col style={{ padding: 6, paddingRight: 15 }} >
                                            <Popover placement="leftBottom" trigger="hover" visible={this.state.visiblePopoverKllClt} onVisibleChange={this.handlePopoverVisibleChangeKllClt} content={(<div><p>Kill all running processes and<br></br>clear share memory for the selected date</p></div>)} title="Kill Client Date" >
                                                <Button id="kill_client_date_btn" type="primary" icon="close-square" style={{ height: 38, width: 38, fontSize: 20, padding: "auto" }} onClick={this.showConfirmKllClt.bind(this)} />
                                            </Popover>
                                        </Col>
                                        <Divider type="vertical" style={{ fontSize: 38 }} />
                                        <Col style={{ padding: 6, paddingLeft: 15, width: 58 }} >

                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        </div>
                    )
                }
            }
        } else {
            aTempCards.push(
                <div className="item" style={{ width: 200, float: "center", display: "none" }}>
                    <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ padding: 8, backgroundColor: "lightblue", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }} >
                        <div>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <h4>Schedule All</h4>
                                </Col>
                            </Row>
                            <div style={{ height: 26 }} />
                            <Row type="flex" justify="space-between" align="middle">
                                <Button className="schedule_all_btn" type="primary" style={{ width: 130, margin: "auto" }} onClick={(e) => this.handleBtnClkAll(e)}>Schedule All</Button>
                                <Button className="stop_all_btn" type="danger" style={{ width: 130, margin: "auto", display: "none" }} onClick={(e) => this.handleBtnStopAll(e)}>Stop All</Button>
                            </Row>
                            <div style={{ height: 29 }} />
                            <Row type="flex" justify="space-between" align="middle">
                                <Button id="reset_all_btn" type="primary" style={{ width: 130, margin: "auto" }} onClick={(e) => this.handleBtnClkAll(e)}>Rest Schedules</Button>
                            </Row>
                            <div style={{ height: 23 }} />
                        </div>
                    </Card>
                </div>
            )
        }
        for (var i = 0; i < props.data.length; i++) {
            if (!this.isEmptyObj(props.data[i])) {
                if (props.data[i].mobility_list.toUpperCase() === "WC") {
                    aWheelchairImg = <Image style={{ width: 30, height: 30, border: 0/*, borderRadius: "50%" */ }}
                        src={require("../img/wc_icon.png")} />;
                } else {
                    aWheelchairImg = <Image style={{ width: 30, height: 30, border: 0, display: "none" }}
                        src="https://cdn.pixabay.com/photo/2012/04/01/19/22/sign-24149_960_720.png" />;
                }
                let aStatusTxt = "Never Ran", aStatusTxtStyle = { color: 'Crimson' }, aDoneTime = "";
                /* if (this.state.isRunning) {
                    aStatusTxt = "Status: Pending";
                } */
                if (props.data[i].when_started != null && props.data[i].when_started.length != 0) {
                    aStatusTxt = "Running";
                    aStatusTxtStyle = { color: '#2acd3f' };
                }
                if (props.data[i].when_ended != null && props.data[i].when_ended.length != 0) {
                    aStatusTxt = "Done";
                    aStatusTxtStyle = { color: 'DodgerBlue' };
                    let aDateTimeElements = props.data[i].when_ended.split(" ");
                    if (aDateTimeElements != null && aDateTimeElements.length > 2) {
                        let aDate = aDateTimeElements[0];
                        let aTime = aDateTimeElements[1];
                        let aAmPm = aDateTimeElements[2];
                        let aDateElements = aDate.split("-");
                        let aTimeElements = aTime.split("\:");
                        if (aDateElements != null && aDateElements.length > 1 && aTime != null && aTime.length > 1 && aAmPm != null && aAmPm.length > 0) {
                            aDoneTime = aDateElements[0] + "/" + aDateElements[1] + "  " + aTimeElements[0] + ":" + aTimeElements[1] + aAmPm;
                        }
                    }

                }
                let aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
                if (props.activeCardIdx === i + 1) {
                    aBodyStyle = { padding: 8, backgroundColor: "LightCyan", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
                }
                aTempCards.push(
                    <div className="item" style={{ width: 200 }} >
                        <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={aBodyStyle} >
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <h4>{props.data[i].oper_id}</h4>
                                </Col>
                                <Col>
                                    <h5>{props.data[i].route_type}</h5>
                                </Col>
                            </Row>
                            <Steps direction="vertical" size="small" current={3} progressDot style={{ height: 88 }}>
                                <Step title={props.data[i].region} />
                                <Step title={props.data[i].szone} />
                            </Steps>
                            <div>
                                <Row type="flex" justify="space-between" align="middle">
                                    <Col>
                                        <h4>{props.data[i].sorder}</h4>
                                    </Col>
                                    <Col>
                                        {aWheelchairImg}
                                    </Col>
                                    <Col>
                                        <Button id={"run_btn_" + props.data[i].sorder} type="primary" onClick={(e) => this.handleRunBtnClkRun(e)}>Schedule</Button>
                                        <Button id={"stop_btn_" + props.data[i].sorder} type="danger" style={{ display: "none" }} onClick={(e) => this.handleStopBtnClkRun(e)}>Stop</Button>
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ width: "100%", height: 1, left: "50%", backgroundColor: "Gainsboro", marginTop: 3 }} />
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <font size="2"><b>Status </b><b style={aStatusTxtStyle}>{aStatusTxt}</b></font>
                                </Col>
                                <Col>
                                    <font size="1"><b>{aDoneTime}</b></font>
                                </Col>
                            </Row>
                        </Card>
                    </div>
                )
            }
        }
        this.setState({
            cards: aTempCards
        });
    }

    isEmptyObj(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }
        return JSON.stringify(obj) === JSON.stringify({});
    }

    render() {
        let settings = {};
        if (this.state.cards == null || this.state.cards.length < 3) {
            settings = {
                dots: false,
                infinite: false,
                centerPadding: "60px",
                slidesToShow: 2,
                speed: 500,
                swipeToSlide: true,
                focusOnSelect: true,
                variableWidth: true,
                rows: 1,
                slidesPerRow: 1,
                initialSlide: 1,
            };
        } else {
            settings = {
                dots: false,
                className: "center",
                centerMode: true,
                infinite: false,
                centerPadding: "60px",
                slidesToShow: 1,
                speed: 500,
                swipeToSlide: true,
                focusOnSelect: true,
                variableWidth: true,
                rows: 1,
                slidesPerRow: 1,
                initialSlide: 1,
                afterChange: current => this.onActiveCardIdxChange(current)
            };
        }
        return (
            <Slider {...settings} style={{ height: 100 }} >
                {this.state.cards}
            </Slider>
        );
    }
}

export default SchedulingOrderSlideCards;



// WEBPACK FOOTER //
// ./src/Componets/SchedulingOrderSlideCards.js